import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BarRentabilidadPorEmpresa from '../BarRentabilidadPorEmpresa/BarRentabilidadPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaInicioPeriodoMesActualFunc, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

import * as actions from '../../../../store/actions/index';

const MultiChartRentabilidadPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <BarRentabilidadPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Resultado por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalRentabilidad)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.rentabilidades}
                onChangeViewClick={handleChangeView}
                title={`Resultado por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalRentabilidad)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
      rentabilidades: state.multiempresa.rentabilidadPorEmpresa.rentabilidades,
      loading: state.multiempresa.rentabilidadPorEmpresa.loading,
      totalRentabilidad: state.multiempresa.rentabilidadPorEmpresa.totalRentabilidad,
      estaCargado: state.multiempresa.rentabilidadPorEmpresa.estaCargado,
      estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.rentabilidadMultiempresa
    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
      onLoadChart: () => dispatch(actions.loadRentabilidadPorEmpresa())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartRentabilidadPorEmpresa);